import { render, staticRenderFns } from "./ForwardToStripe.vue?vue&type=template&id=2f4152f7&lang=pug&"
import script from "./ForwardToStripe.vue?vue&type=script&lang=ts&"
export * from "./ForwardToStripe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports